import { render, staticRenderFns } from "./Map2.vue?vue&type=template&id=1961dd54&scoped=true&"
import script from "./Map2.vue?vue&type=script&lang=js&"
export * from "./Map2.vue?vue&type=script&lang=js&"
import style0 from "./Map2.vue?vue&type=style&index=0&id=1961dd54&scoped=true&lang=css&"
import style1 from "./Map2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1961dd54",
  null
  
)

export default component.exports